// Idle auto-logout. Logs the user out after IDLE_MS of no interaction, and also
// on app load if the last recorded activity is already older than the window
// (so reopening the tab/URL after being away requires logging in again).
//
// Activity timestamp lives in localStorage so it is shared across tabs.

const KEY      = 'todo_last_active'
const IDLE_MS  = 30 * 60 * 1000   // 30 minutes
const CHECK_MS = 30 * 1000        // re-check twice a minute
const WRITE_THROTTLE_MS = 5000    // don't hammer localStorage on every mousemove

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click']

let lastWrite = 0

function stamp() {
  const now = Date.now()
  if (now - lastWrite < WRITE_THROTTLE_MS) return
  lastWrite = now
  try { localStorage.setItem(KEY, String(now)) } catch {}
}

function lastActive() {
  const v = Number(localStorage.getItem(KEY))
  return Number.isFinite(v) ? v : 0
}

/**
 * @param {() => boolean} isLoggedIn  reactive-ish check for an active session
 * @param {() => void}    onIdle      called once when the session has gone idle
 * @returns {() => void}  teardown
 */
export function useIdleTimeout(isLoggedIn, onIdle) {
  // Reopening after the window has already elapsed → log out straight away.
  if (isLoggedIn() && lastActive() && Date.now() - lastActive() > IDLE_MS) {
    onIdle()
    return () => {}
  }

  stamp()
  const onActivity = () => stamp()
  ACTIVITY_EVENTS.forEach(ev => window.addEventListener(ev, onActivity, { passive: true }))

  const timer = setInterval(() => {
    if (!isLoggedIn()) return
    if (Date.now() - lastActive() > IDLE_MS) onIdle()
  }, CHECK_MS)

  return () => {
    clearInterval(timer)
    ACTIVITY_EVENTS.forEach(ev => window.removeEventListener(ev, onActivity))
  }
}

export function clearIdleStamp() {
  try { localStorage.removeItem(KEY) } catch {}
}
